import api from '@/helpers/api'

const API_READ = '/api/access-token/';
const API_CREATE = API_READ;
const API_DELETE = API_READ;

export default {
    namespaced: true,
    state: {
        status: '',
        tokens: [],
        errMessage: ''
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, {message}) {
            state.status = 'error',
            state.errMessage = message
        },
        read(state, {tokens}) {
            state.tokens = [...tokens];
        }
    },
    actions: {
        create({ commit }, { data }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                    .then(response => {
                        commit('success');

                        return resolve(response.data.data);
                    }).catch(err => {
                        commit('error', {message: err});
                        return reject(err);
                    });
            });
        },
        read({commit}) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', API_READ)
                .then(response => {
                    const tokens = response.data.data.tokens;
                    commit('read', {tokens});
                    commit('success');

                    return resolve(true);
                }).catch(err => {
                    commit('error', {message: err});
                    return reject(err);
                });
            });
        },
        delete({commit}, id) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                .then(() => {
                    commit('success');

                    return resolve(true);
                }).catch(err => {
                    commit('error', {message: err});
                    return reject(err);
                });
            });
        }
    },
    getters: {
        getTokens: () => (state) => state.tokens
    }
}